// extracted by mini-css-extract-plugin
module.exports = {"FinishedQuiz":"FinishedQuiz_FinishedQuiz__1hvzN","success":"FinishedQuiz_success__36gfU","error":"FinishedQuiz_error__1G-yc"};